import React from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import styles from "./styles/styles.module.scss";
import Image from "next/image";
import { FormattedMessage } from "react-intl";
import { useRouter } from "next/router";
import RequestForm from "../Shared/RequestForm";
import stylesContact from "@/styles/contact.module.scss";
import { handleImageLink } from "../helpers/functions";
import SarIcon from "../../assets/images/svg/sar.svg";

const SinglePersonnel = ({ person, countries }) => {
  const { locale } = useRouter();

  const handlePdfDownload = async () => {
    const pdfUrl = person?.name?.file;

    const response = await fetch(pdfUrl);
    const blob = await response.blob();

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `${person?.name?.ar}.pdf`;
    link.click();

    window.URL.revokeObjectURL(link.href);
  };
  const getLocalizedValue = (field, locale, fallback = "-") => {
    if (typeof field === "object" && field !== null) {
      const ar = field?.ar?.trim?.();
      const en = field?.en?.trim?.();
      if (!ar && !en) return fallback;
      const localized = field?.[locale]?.trim?.();
      return localized || ar || en || fallback;
    }
    if (typeof field === "string") {
      return field.trim() || fallback;
    }
    return fallback;
  };

  return (
    <Container className={`${styles["single-personnel"]}`}>
      <div className="profile-container">
        <div className="image-div">
          <Image
            src={handleImageLink(person.image)}
            width={100}
            height={100}
            alt={person.name.ar}
          />
        </div>
        <div className="content">
          <Row>
            <Col md={12} sm={12} className="  d-flex d-xl-none firstcol "></Col>
            <Col className="info-data" xxl={7} xl={7} lg={7} md={12} sm={12}>
              <h2>
                <span className="key">
                  <FormattedMessage id="name" />:{" "}
                </span>
                <span className="value">
                  {person?.name?.[locale] || person?.name?.ar || ""}
                </span>
              </h2>

              <h2>
                <span className="key">
                  <FormattedMessage id="passportNumber" />:{" "}
                </span>
                <span className="value">
                  {person?.passportNumber?.toString().trim() || "-"}
                </span>
              </h2>

              <h2>
                <span className="key">
                  <FormattedMessage id="job" />:{" "}
                </span>
                <span className="value">
                  {getLocalizedValue(person?.job, locale)}
                </span>
              </h2>

              <h2>
                <span className="key">
                  <FormattedMessage id="nationality" />:{" "}
                </span>
                <span className="value">
                  {getLocalizedValue(person?.country?.name, locale)}
                </span>
              </h2>

              <h2>
                <span className="key">
                  <FormattedMessage id="age" />:{" "}
                </span>
                <span className="value">
                  {person?.age?.toString().trim() || "-"}{" "}
                  <FormattedMessage id="year" />
                </span>
              </h2>

              <h2>
                <span className="key">
                  <FormattedMessage id="monthlysalary" />:{" "}
                </span>
                <span className="value">
                  {person?.salary}{" "}
                  <Image src={SarIcon} alt="" width={20} height={20} />
                </span>
              </h2>
              {person?.recruitmentFees && (
                <h2>
                  <span className="key">
                    <FormattedMessage id="recruitmentFees" />:{" "}
                  </span>
                  <span className="value">
                    {person?.recruitmentFees}{" "}
                    <Image src={SarIcon} alt="" width={20} height={20} />
                  </span>
                </h2>
              )}

              <h2>
                <span className="key">
                  <FormattedMessage id="experienceYears" />:{" "}
                </span>
                <span className="value">
                  {person?.name?.experienceYears?.toString().trim() || "-"}
                </span>
              </h2>

              <h2>
                <span className="key">
                  <FormattedMessage id="religion" />:{" "}
                </span>
                <span className="value">
                  {getLocalizedValue(person?.religion, locale)}
                </span>
              </h2>

              <h2>
                <span className="key">
                  <FormattedMessage id="office" />:{" "}
                </span>
                <span className="value">
                  {getLocalizedValue(person?.foreignExportOffice, locale)}
                </span>
              </h2>
            </Col>
            <Col
              className="cv-data d-flex flex-column align-items-center gap-2"
              xxl={5}
              xl={5}
              lg={5}
              md={12}
              sm={12}
            >
              <div className="cv-image">
                <Image
                  src={person?.name?.pdfImage}
                  width={400}
                  height={600}
                  alt={person?.name.ar}
                  layout="responsive"
                  quality={100}
                />
              </div>
              <div className="download-btn w-100">
                <Button
                  onClick={handlePdfDownload}
                  className="main-btn text-white w-100 py-2"
                >
                  <FormattedMessage id="download" />
                  {" PDF"}
                </Button>
              </div>
            </Col>
          </Row>
          <hr className="my-5" />
          <Row className={`contact-page ${stylesContact["contact"]}`}>
            <h2 className="fw-bolder h4">
              <FormattedMessage id="applyRequest" />{" "}
            </h2>
            <RequestForm person={person} countries={countries} />
          </Row>
        </div>
      </div>
    </Container>
  );
};
export default SinglePersonnel;
